module.exports = __webpack_public_path__ + "img/wodeshijuan.11724b1e.png";